import React from 'react'
import { translate } from 'react-i18next'
import { compose, pure } from 'recompose'
import styles from './linkComponent.scss'
import PropTypes from 'prop-types'
export function Link (props: Props) {
  const { t } = props
  if (props.link) {
    return (
      <a href={props.link.url} target='blank' className={props.className}>
        {t(`form:${props.link.text}`)}
      </a>
    )
  } else {
    return false
  }
}
Link.propTypes = {
  t: PropTypes.func.isRequired,
  link: PropTypes.oneOfType([
    PropTypes.shape({
      url: PropTypes.string,
      text: PropTypes.string
    }),
    PropTypes.bool
  ]),
  className: PropTypes.any
}

export default compose(pure, translate())(Link)



// WEBPACK FOOTER //
// ./src/components/link/linkComponent.js